export const percentageChange = (initial: number, final: number): number => {
  let percentageChange = 0;
  if (initial != 0) {
    percentageChange = ((final - initial) / initial) * 100;
  }
  return Math.abs(percentageChange);
};
